<script lang="ts">
  import { listStudents } from '$lib/api/users';
  import type { StudentListRecord, User } from '$lib/api/types';
  import type { TableHeaderItem } from '$lib/componentTypes';
  import UserList from '$lib/components/users/UserList.svelte';

  function buildNewUserObject(user: User): StudentListRecord {
    return {
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      studentId: user.studentId!,
      created: user.created,
    };
  }

  const additionalHeaders: TableHeaderItem<StudentListRecord>[] = [
    {
      title: 'Student ID',
      sortable: false,
      alignment: 'end',
      selectValue: s => s.studentId,
    },
  ];
</script>

<UserList
  route="students"
  role="student"
  loadData={listStudents}
  {buildNewUserObject}
  {additionalHeaders}
  headerText="Students"
/>
